module.exports = __webpack_public_path__ + "static/media/cover-europe.e2dd27b6.jpg";